/** @jsx jsx */
import React from "react";
import { jsx, Flex, Text } from "theme-ui";

const StatsItem = ({ statsItem, ...props }) => {
  const { heading, description } = statsItem;

  return (
    <Flex
      {...props}
      sx={{
        flexDirection: "column",
      }}
    >
      {heading && (
        <Text
          variant="stats"
          sx={{
            fontSize: "60px",
            mb: "20px",
          }}
        >
          {heading}
        </Text>
      )}
      {description && (
        <Text variant="stats" sx={{ fontSize: "20px" }}>
          {description}
        </Text>
      )}
    </Flex>
  );
};

export default StatsItem;
